import { CheckoutPayload } from 'types/vsb-sdk/checkout';

//START GENAI@GHCOPILOT
/**
 * Retrieves the checkout action code from the provided checkout response.
 * If the action code is 'COMPLETE', it returns 'SUCCESS', otherwise it returns the action code itself.
 *
 * @param checkoutResponse - The checkout response object.
 * @returns The checkout action code.
 */
export function getCheckoutActionCode(checkoutResponse: CheckoutPayload): string {
  if (checkoutResponse.dcfActionCode === 'COMPLETE') {
    return 'SUCCESS';
  }

  if (checkoutResponse.dcfActionCode === 'CANCEL') {
    return 'CHANGE_CARD';
  }

  return checkoutResponse.dcfActionCode;
}
//END GENAI@GHCOPILOT
